import React, { useEffect, useState, useRef } from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table, Input, Modal, message } from 'antd';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import * as api from '@/apis/client/school';

const TableBox = ({
    lessions,
    onTableOperate,
    expKeys,
    getList,
}) => {

    const [lessionList, setLessionList] = useState(lessions || []);
    const [sortIndex, setSortIndex] = useState();
    const [sortVal, setSortVal] = useState();
    

    useEffect(()=>{
        document.body.addEventListener('click', cancelSetSort);
        return ()=>{
            document.body.removeEventListener('click', cancelSetSort);
        };
    }, []);

    useEffect(()=>{
        setLessionList(lessions);
    }, [lessions]);

    const cancelSetSort = ()=>{
        setSortIndex();
    };

    const onControlLogOperateCell = (text, item)=>{
        let isLession = item.pid != 0;
        
        return <div className={styles.action}>
            <div className={styles.item} onClick={() => onTableOperate(text, 'edit', item)} >编辑</div>
            <div className={styles.item} onClick={() => onTableOperate(text, 'delete', item)} >删除</div>
            { isLession ? (<div className={styles.item} onClick={() => onTableOperate(text, 'move', item)} >移动</div>) : null}
        </div>;
    };

    const onSortClick = (id, sortNum)=>{
        setSortIndex(id);
        setSortVal(sortNum);
    };

    const onSortChange = (e)=>{
        let reg = /[^\d.]/g;
        let val = e.target.value.trim().replace(reg, '');
        let dotIndex = val.indexOf('.');
        if(dotIndex > 0){
            let intStr = val.substring(0,dotIndex+1);
            let floatStr = val.substring(dotIndex+1).replace(/\./g,'');
            if(floatStr.length > 2){
                floatStr = floatStr.substring(0,2);
            }
            val = intStr + floatStr;
        }
        
        setSortVal(val);
    };

    const saveSort = (e)=>{
        let oldVal = e.target.dataset.val;
        let ids = e.target.id.split('_');
        let pid = ids[0];
        let id = ids[1];
        let sortNum = e.target.value.trim();

        if(sortNum == ''){
            sortNum = oldVal;
        }

        let tempList = lessionList.map(v=>{
            if(v.pid == 0 && pid == 0 && v.id == id){
                v.sortNum = sortNum;
            }else{
                if(v.children.length){
                    v.children = v.children.map(item=>{
                        if(item.pid == pid && item.id == id){
                            item.sortNum = sortNum;
                        }
                        return item;
                    });
                }
            }
            return v;
        });

        setLessionList(tempList);
        setSortIndex();
        setSortVal();

        if(oldVal == sortNum){
            return false;
        }
        
        api.sortClassLession({id, sortNum}).then(res=>{
        }).catch(err=>{
            message.error(err.message);
        }).finally(()=>{
            getList();
        });
    };

    const renderSort = (sort, item)=>{
        let id = item.pid + '_' +item.id;
        let sortNum = item.sortNum;
        return <div onClick={e=>{e.stopPropagation();}}>
            {sortIndex == id ? null : <div className={styles.sort} onClick={()=>{onSortClick(id, sortNum);}}>{item.sortNum}</div>}
            {sortIndex == id ? <Input id={id} data-val={item.sortNum} className={styles.sortInput} autoFocus onFocus={e=>{e.target.select();}} onBlur={saveSort} onInput={onSortChange} value={sortVal} /> : null}
        </div>;
    };

    const onExpand = (expanded, record)=>{
        onTableOperate(expanded, 'expand', record);
    };

    const renderLessionName = (val, item)=>{
        return <span>{item.name}</span>;
    };

    const controlLogColumns = [
        {
            title: '课程类型/课程',
            dataIndex: 'type',
            width: '200px',
            align: 'left',
            onCell: tooltipStyle,
            render: renderLessionName
        },
        {
            title: '学习目的',
            dataIndex: 'studyPurpose',
            width: '300px',
            align: 'left',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '排序',
            dataIndex: 'sortNum',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderSort
        },
        {
            title: '预计学习时长（单位分钟）',
            dataIndex: 'estimatedStudyTime',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '课程形式',
            dataIndex: 'courseForm',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: '150px',
            align: 'center',
            fixed: 'right',
            onCell: tooltipStyle,
            render: onControlLogOperateCell
        }
    ];

    const _expandIcon = (data)=>{
        if(data.record.pid != 0){
            return null;
        }
        
        return data.expanded ? (
            <CaretDownOutlined className={styles.expandIcon} onClick={e => data.onExpand(data.record, e)} />
          ) : (
            <CaretRightOutlined className={styles.expandIcon} onClick={e => data.onExpand(data.record, e)} />
          );
    };

    return <div className={styles.tableContainer}>
        <Table
            childrenColumnName={'children'}
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={controlLogColumns}
            indentSize={40}
            expandedRowKeys={expKeys}
            expandable={{expandIcon: _expandIcon}}
            onExpand={onExpand}
            dataSource={lessionList}
            pagination={false}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    lessions: PropTypes.array,//表格数据
    onTableOperate: PropTypes.func,//表格操作
    expKeys: PropTypes.array,
    getList: PropTypes.func
};

export default TableBox;